export const jobEmploymentTypesCz = {
  jobEmploymentTypes: {
    'full_time': 'Plný úvazek',
    'part_time': 'Částečný úvazek',
    'contract': 'Dohoda',
    'freelance': 'Práce na živnost',
    'temporary': 'Brigáda',
    'internship': 'Stáž',
    'seasonal': 'Sezónní práce'
  }
};
